import React, { useState } from "react";
import { Container, Navbar, NavDropdown, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo.png";

const Header = () => {
  const [active, setActive] = useState("home");
  return (
    <div>
      <Navbar collapseOnSelect expand="lg" className="gvr-header" fixed="top">
        <Container>
          <Navbar.Brand>
            <Link to="/">
              <img src={logo} className="img-fluid" alt="logo" />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav
              className="ms-auto sub-nav"
              activeKey={active}
              onSelect={(selectedKey) => setActive(selectedKey)}
            >
              <Nav.Item>
                <Nav.Link eventKey="home" as={Link} to="/">
                  Home
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link eventKey="about" as={Link} to="/about-us">
                  About Us
                </Nav.Link>
              </Nav.Item>

              <NavDropdown title="Our Services" id="basic-nav-dropdown">
                <NavDropdown.Item
                  eventKey="services"
                  as={Link}
                  to="/our-services"
                >
                  Our Services
                </NavDropdown.Item>

               

                <NavDropdown.Item
                  eventKey="shuttle"
                  as={Link}
                  to="/employee-transportation-services"
                >
                  Employee Transportation Services
                </NavDropdown.Item>
                <NavDropdown.Item
                  eventKey="shuttle"
                  as={Link}
                  to="/shuttle-services"
                >
                  Shuttle Services
                </NavDropdown.Item>

                <NavDropdown.Item
                  eventKey="airport"
                  as={Link}
                  to="/airport-services"
                >
                  Airport Services
                </NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title="Safety" id="basic-nav-dropdown">
                <NavDropdown.Item
                  eventKey="safety"
                  as={Link}
                  to="/safety-standards"
                >
                  Safety Standards
                </NavDropdown.Item>
                {/* <NavDropdown.Item eventKey="covid" as={Link} to="/covid-safety">
                  Covid Safety
                </NavDropdown.Item> */}
              </NavDropdown>

              <Nav.Link eventKey="fleets" as={Link} to="/our-fleets">
                Our Fleets
              </Nav.Link>
             
              <Nav.Link eventKey="contact" as={Link} to="/contact-us">
                Contact Us
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

export default Header;
